import {useConfigProvider} from "../../../config/ConfigProvider"

export function caseStudiesEndpoints() {
  const {cmsBlApiUrl, cmsBlApiApimKey, cmsBlApiFunctionKey} =
    useConfigProvider()

  const headers = {
    "Content-Type": "application/json",
    "X-Functions-Key": cmsBlApiFunctionKey || "",
    "Ocp-Apim-Subscription-Key": cmsBlApiApimKey || "",
  }

  const getCaseStudies = async () => {
    const url = `${cmsBlApiUrl}/case-studies/list`
    return await fetch(url, {
      headers: headers,
    }).then((res) => res.json())
  }

  return {
    getCaseStudies,
  }
}
